var z = Object.defineProperty;
var v = (p, e, n) => e in p ? z(p, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : p[e] = n;
var s = (p, e, n) => (v(p, typeof e != "symbol" ? e + "" : e, n), n);
import { fabric as l } from "fabric";
import { createLogoFabricImg as W, createLogoOuterBox as X } from "./index.es393.js";
import { createCategoryFabricObj as V } from "./index.es394.js";
import { createTenantsGroupFabricObj as Y } from "./index.es395.js";
import { createMetricsFabricObj as q } from "./index.es396.js";
import { createMetricsLabels as U } from "./index.es397.js";
import { isMarketEntity as j } from "./index.es281.js";
import "./index.es175.js";
import { DEFAULT_CALLOUT_BOX_SIZE as G, getCalloutBoxSizeData as Z, calcFontSize as S, SIZES_DEFINITIONS as K } from "./index.es176.js";
import { createHeaderTxtboxFabricObj as _, createHeaderTxtboxContainer as J } from "./index.es398.js";
const c = {
  idle: {
    default: {
      originX: "left",
      originY: "top",
      fill: "white",
      rx: 8,
      ry: 8
    },
    light: {
      stroke: "#49565D",
      strokeWidth: 1
    },
    dark: {
      stroke: "#E5E5E5",
      strokeWidth: 2
    }
  },
  dragStart: {
    default: {},
    light: {},
    dark: {}
  },
  select: {
    default: {},
    light: {},
    dark: {}
  },
  selectedPOI: {
    default: {},
    light: {},
    dark: {}
  }
}, Q = 1;
class ut {
  constructor(e) {
    s(this, "objType");
    s(this, "layerGroupId");
    s(this, "subLayerId");
    s(this, "combinedLayerId");
    s(this, "styleType");
    s(this, "poiInfo");
    s(this, "poiCalloutBoxConfig");
    s(this, "poiCalloutLogosList");
    s(this, "calloutBoxSizeData");
    //Rendered Fabric Objects
    s(this, "thumbnailImg");
    s(this, "thumbnailContainer");
    s(this, "thumbnailGroup");
    s(this, "nameTextbox");
    s(this, "addressTextbox");
    s(this, "headerContainer");
    s(this, "headerGroup");
    s(this, "visitRank");
    s(this, "tenantsGroup");
    s(this, "outerBox");
    s(this, "tenantsCalloutBoxGroup");
    s(this, "maxCalloutBoxWidth");
    s(this, "logoSize");
    s(this, "MAX_HEADER_WIDTH");
    s(this, "MAX_HEADER_WIDTH_WITHOUT_LOGO");
    s(this, "MIN_HEADER_HEIGHT");
    s(this, "PADDING", 8);
    s(this, "PADDINGx2", this.PADDING * 2);
    s(this, "NAME_ADDRESS_GAP", 2);
    s(this, "NAME_MINIMUM_HEIGHT", 20);
    s(this, "ADDRESS_MINIMUM_HEIGHT", 16);
    s(this, "isSelectable", !0);
    s(this, "addLogo", async () => {
      const e = this.logoSize, n = this.logoSize;
      if (this.poiInfo.logoImgBlob) {
        const r = await W({
          logoImgBlob: this.poiInfo.logoImgBlob,
          logoImgURL: this.poiInfo.logoImgURL,
          targetWidth: e,
          targetHeight: n,
          padding: 1,
          devicePixelRatio: 2
        });
        this.thumbnailImg = r;
      }
      if (!this.thumbnailImg) {
        const r = await V({
          categoryInfo: this.poiInfo.category_info,
          categorySvgUrl: this.poiInfo.categorySVGURL,
          entitySection: this.poiInfo.entity_section
        });
        this.thumbnailImg = r;
      }
    });
    s(this, "addNameTextbox", () => {
      const {
        propertyNameFontColor: e,
        propertyNameFontFamily: n,
        propertyNameFontOpacity: r,
        propertyNameFontSize: a,
        propertyNameFontWeight: i
      } = this.poiCalloutBoxConfig;
      this.nameTextbox = _({
        txt: this.poiInfo.mainHeader,
        fontOptions: {
          fillColor: e,
          fontFamily: n,
          fontStyle: "normal",
          fontSize: S(
            a,
            this.calloutBoxSizeData.fontSizeMultiplier
          ),
          fontWeight: i,
          fontOpacity: r
        }
      });
    });
    s(this, "addAddressTextbox", () => {
      const {
        propertyAddressFontColor: e,
        propertyAddressFontFamily: n,
        propertyAddressFontOpacity: r,
        propertyAddressFontSize: a,
        propertyAddressFontWeight: i
      } = this.poiCalloutBoxConfig;
      this.addressTextbox = _({
        txt: this.poiInfo.subHeader,
        fontOptions: {
          fillColor: e,
          fontFamily: n,
          fontStyle: "normal",
          fontSize: S(
            a,
            this.calloutBoxSizeData.fontSizeMultiplier
          ),
          fontWeight: i,
          fontOpacity: r
        }
      });
    });
    s(this, "addVisitsRank", () => {
      const e = j(this.poiInfo), n = U({
        calloutBoxConfig: this.poiCalloutBoxConfig,
        poiInfo: this.poiInfo,
        isMarket: e
      }), r = e ? Q : this.calloutBoxSizeData.columns;
      this.visitRank = q({
        metrics: n,
        maxWidth: this.maxCalloutBoxWidth,
        fontSizeMultiplier: this.calloutBoxSizeData.fontSizeMultiplier,
        columns: r
      });
    });
    s(this, "addTenants", async () => {
      const { tenantsGroupBox: e } = this.poiInfo;
      if (!e)
        return;
      let n;
      const r = this.poiCalloutLogosList;
      r ? n = e.allUniqueTenants.filter(
        (i) => r.includes(i.poiId)
      ) : n = e.top20UniqueTenantLogos;
      const a = await Y({
        logosList: n,
        totalTenantsCount: e.totalTenantCount,
        iconSize: this.calloutBoxSizeData.tenantLogoSize,
        outerboxWidth: this.maxCalloutBoxWidth,
        devicePixelRatio: 2
      });
      a && (this.tenantsGroup = a);
    });
    s(this, "generate", async () => {
      this.thumbnailImg || await this.addLogo();
      const { showPropertyName: e } = this.poiCalloutBoxConfig;
      e && !this.nameTextbox && this.addNameTextbox();
      const { showPropertyAddress: n } = this.poiCalloutBoxConfig;
      n && !this.addressTextbox && this.addAddressTextbox();
      const { showMetrics: r } = this.poiCalloutBoxConfig;
      r && !this.visitRank && this.addVisitsRank(), this.tenantsGroup || await this.addTenants(), this.positionTenantsCalloutBox();
    });
    s(this, "positionTenantsCalloutBox", () => {
      var I, f, T, A, D, k, B, H;
      const { showLogo: r } = this.poiCalloutBoxConfig, a = r && this.thumbnailImg, i = a ? this.MAX_HEADER_WIDTH : this.MAX_HEADER_WIDTH_WITHOUT_LOGO;
      (I = this.nameTextbox) == null || I.set({ width: i - this.PADDINGx2 }), (f = this.addressTextbox) == null || f.set({ width: i - this.PADDINGx2 });
      const { headerContainerColor: t, headerContainerOpacity: o } = this.poiCalloutBoxConfig;
      this.headerContainer = J({
        width: i,
        height: this.MIN_HEADER_HEIGHT,
        fillColor: t,
        opacity: o
      });
      const { showPropertyName: g, showPropertyAddress: m } = this.poiCalloutBoxConfig, x = g && m, N = !x && g, E = !x && m;
      if (x && this.nameTextbox && this.addressTextbox) {
        const d = this.nameTextbox.getBoundingRect().height + 2, h = this.addressTextbox.getBoundingRect().height + 2, w = d + 1 + this.NAME_ADDRESS_GAP;
        this.addressTextbox.set({ top: w });
        const b = new l.Group([this.nameTextbox, this.addressTextbox], {
          left: this.PADDING
        }), O = Math.max(
          d + h + this.PADDINGx2,
          this.MIN_HEADER_HEIGHT
        );
        this.headerContainer.set({ height: O }), b.set({ originY: "center", top: this.headerContainer.getCenterPoint().y }), this.headerGroup = new l.Group([this.headerContainer, b]);
      }
      if (N && this.nameTextbox) {
        const d = this.nameTextbox.getBoundingRect().height + 2, h = new l.Group([this.nameTextbox], {
          left: this.PADDING
        }), w = Math.max(d + this.PADDINGx2, this.MIN_HEADER_HEIGHT);
        this.headerContainer.set({ height: w }), h.set({ originY: "center", top: this.headerContainer.getCenterPoint().y }), this.headerGroup = new l.Group([this.headerContainer, h]);
      }
      if (E && this.addressTextbox) {
        const d = this.addressTextbox.getBoundingRect().height + 2, h = new l.Group([this.addressTextbox], {
          left: this.PADDING
        }), w = Math.max(
          d + this.PADDINGx2,
          this.MIN_HEADER_HEIGHT
        );
        this.headerContainer.set({ height: w }), h.set({ originY: "center", top: this.headerContainer.getCenterPoint().y }), this.headerGroup = new l.Group([this.headerContainer, h]);
      }
      if (a && this.thumbnailImg) {
        this.thumbnailContainer = X({
          targetWidth: this.logoSize,
          targetHeight: this.headerContainer.getBoundingRect().height
        });
        const { x: d, y: h } = this.thumbnailContainer.getCenterPoint();
        this.thumbnailImg.set({
          top: h,
          left: d,
          originX: "center",
          originY: "center"
        }), this.thumbnailGroup = new l.Group([this.thumbnailContainer, this.thumbnailImg]);
      }
      const u = 4, M = u * 2, R = this.maxCalloutBoxWidth + M, C = Math.max(R, K[0].calloutBoxRange.min), P = this.getOuterboxHeight(u);
      this.outerBox = new l.Rect({
        width: C,
        height: P,
        ...c.idle.default,
        ...c.idle[this.styleType]
      }), (T = this.headerGroup) == null || T.set({
        left: C - u,
        top: u,
        originX: "right"
      });
      const y = (A = this.headerGroup) == null ? void 0 : A.getBoundingRect().height, F = (D = this.headerGroup) == null ? void 0 : D.getCenterPoint().y;
      (k = this.thumbnailGroup) == null || k.set({
        left: u,
        top: F,
        originY: "center"
      }), (B = this.visitRank) == null || B.set({
        left: u,
        top: y ? y + M : u
      });
      const { x: L } = this.outerBox.getCenterPoint();
      (H = this.tenantsGroup) == null || H.set({
        left: L,
        top: P - u,
        originX: "center",
        originY: "bottom"
      });
    });
    s(this, "getTenantsCalloutBoxObjs", () => (this.tenantsCalloutBoxGroup = new l.Group(
      [
        this.outerBox,
        this.headerGroup,
        this.thumbnailGroup,
        this.visitRank,
        this.tenantsGroup
      ].filter((e) => e)
    ), this.tenantsCalloutBoxGroup));
    s(this, "getOuterboxHeight", (e) => {
      let n = 0, r = 1;
      return this.headerGroup && (n += this.headerGroup.getBoundingRect().height, r += 1), this.visitRank && (n += this.visitRank.getBoundingRect().height, r += 1), this.tenantsGroup && (n += this.tenantsGroup.getBoundingRect().height, r += 1), n + e * r;
    });
    s(this, "updateStyle", (e, n = "idle") => {
      var r;
      this.styleType = e, (r = this.outerBox) == null || r.set({
        ...c.idle.default,
        ...c.idle[this.styleType],
        ...c[n].default,
        ...c[n][this.styleType]
      });
    });
    this.objType = "TenantsCalloutBox", this.styleType = e.styleType, this.layerGroupId = e.layerGroupId, this.subLayerId = e.subLayerId, this.combinedLayerId = e.combinedLayerId, this.poiInfo = e.poiInfo, this.poiCalloutLogosList = e.poiCalloutLogosList;
    const { showPropertyName: n, showPropertyAddress: r, calloutBoxSize: a } = e.poiCalloutBoxConfig;
    n || r ? this.poiCalloutBoxConfig = e.poiCalloutBoxConfig : this.poiCalloutBoxConfig = {
      ...e.poiCalloutBoxConfig,
      showLogo: !1
    };
    const { sizeId: i, rangePosition: t } = a || G;
    this.calloutBoxSizeData = Z(this.objType, i, t), this.maxCalloutBoxWidth = this.calloutBoxSizeData.size, this.logoSize = this.calloutBoxSizeData.calloutBoxLogoSize + 13, this.MAX_HEADER_WIDTH = this.maxCalloutBoxWidth - this.logoSize - this.PADDING / 2, this.MAX_HEADER_WIDTH_WITHOUT_LOGO = this.maxCalloutBoxWidth, this.MIN_HEADER_HEIGHT = this.logoSize;
  }
  hasSameProps(e) {
    var g, m;
    if (e.drawType !== "TenantsCalloutBox")
      return !1;
    const n = this.calloutBoxSizeData.id, r = ((m = (g = e.calloutBoxConfig) == null ? void 0 : g.calloutBoxSize) == null ? void 0 : m.sizeId) || G.sizeId, a = this.poiInfo, i = e.poiInfo, t = this.poiCalloutBoxConfig, o = e.calloutBoxConfig;
    return i && o && a.visitMetric.label === i.visitMetric.label && a.visitMetric.value === i.visitMetric.value && a.visitMetric.isRestricted === i.visitMetric.isRestricted && a.visitorsMetric === i.visitorsMetric && a.visitFrequencyMetric === i.visitFrequencyMetric && a.dwellTimeMetric === i.dwellTimeMetric && a.salesMetric === i.salesMetric && a.salesSqFtMetric === i.salesSqFtMetric && a.transactionsMetric === i.transactionsMetric && a.popstatsPopulationMetrics === i.popstatsPopulationMetrics && a.censusPopulationMetrics === i.censusPopulationMetrics && a.mosaicPopulationMetrics === i.mosaicPopulationMetrics && a.personaLiveMetrics === i.personaLiveMetrics && a.visitsAudienceMetrics === i.visitsAudienceMetrics && a.marketPopulationMetrics === i.marketPopulationMetrics && a.marketEmployeesMetrics === i.marketEmployeesMetrics && a.marketCensusMetrics === i.marketCensusMetrics && a.marketPopstatsMetrics === i.marketPopstatsMetrics && a.marketDemographicAudience === i.marketDemographicAudience && this.poiInfo.marketWorkforceAudience === i.marketWorkforceAudience && a.mainHeader === i.mainHeader && a.tenantsGroupBox.totalTenantCount === i.tenantsGroupBox.totalTenantCount && this.poiCalloutLogosList === e.poiCalloutLogosList && t.showLogo === o.showLogo && t.showPropertyName === o.showPropertyName && t.showPropertyAddress === o.showPropertyAddress && t.showMetrics === o.showMetrics && t.showMetricsVisits === o.showMetricsVisits && t.showMetricsVisitsRanking === o.showMetricsVisitsRanking && t.metricsRankShowAs === o.metricsRankShowAs && t.metricsRankType === o.metricsRankType && t.metricsDisplayAsNA === o.metricsDisplayAsNA && t.showMetricsVisitors === o.showMetricsVisitors && t.showVisitsFrequency === o.showVisitsFrequency && t.showDwellTime === o.showDwellTime && t.showMetricsVisitsSqFt === o.showMetricsVisitsSqFt && t.showSales === o.showSales && t.showTransactions === o.showTransactions && t.showSalesSqFt === o.showSalesSqFt && t.showAverageTicketSize === o.showAverageTicketSize && t.showCensusMedianHouseholdIncome === o.showCensusMedianHouseholdIncome && t.showCensusAverageHouseholdIncome === o.showCensusAverageHouseholdIncome && t.showCensusPopulation === o.showCensusPopulation && t.showCensusHousehold === o.showCensusHousehold && t.showCensusPopulationDensity === o.showCensusPopulationDensity && t.showCensusMedianAge === o.showCensusMedianAge && t.showCensusPersonsPerHousehold === o.showCensusPersonsPerHousehold && t.showPopstatsMedianHouseholdIncome === o.showPopstatsMedianHouseholdIncome && t.showPopstatsAverageHouseholdIncome === o.showPopstatsAverageHouseholdIncome && t.showPopstatsPopulation === o.showPopstatsPopulation && t.showPopstatsHousehold === o.showPopstatsHousehold && t.showPopstatsPopulationDensity === o.showPopstatsPopulationDensity && t.showPopstatsMedianAge === o.showPopstatsMedianAge && t.showPopstatsPopGrowth2123 === o.showPopstatsPopGrowth2123 && t.showPopstatsPopGrowth2328 === o.showPopstatsPopGrowth2328 && t.showPopstatsPopProjection28 === o.showPopstatsPopProjection28 && t.showPopstatsPersonsPerHousehold === o.showPopstatsPersonsPerHousehold && t.showPopstatsPercentCollegeDegree === o.showPopstatsPercentCollegeDegree && t.showPredominantMosaicSegment === o.showPredominantMosaicSegment && t.showPredominantPersonaLiveSegment === o.showPredominantPersonaLiveSegment && t.showResidentPopulation === o.showResidentPopulation && t.showEmployeesPopulation === o.showEmployeesPopulation && t.showDaytimePopulation === o.showDaytimePopulation && t.showMarketsCensusMedianHouseholdIncome === o.showMarketsCensusMedianHouseholdIncome && t.showMarketsCensusAverageHouseholdIncome === o.showMarketsCensusAverageHouseholdIncome && t.showMarketsCensusPopulation === o.showMarketsCensusPopulation && t.showMarketsCensusHousehold === o.showMarketsCensusHousehold && t.showMarketsCensusPopulationDensity === o.showMarketsCensusPopulationDensity && t.showMarketsCensusMedianAge === o.showMarketsCensusMedianAge && t.showMarketsPopstatsMedianHouseholdIncome === o.showMarketsPopstatsMedianHouseholdIncome && t.showMarketsPopstatsAverageHouseholdIncome === o.showMarketsPopstatsAverageHouseholdIncome && t.showMarketsPopstatsPopulation === o.showMarketsPopstatsPopulation && t.showMarketsPopstatsHousehold === o.showMarketsPopstatsHousehold && t.showMarketsPopstatsPopulationDensity === o.showMarketsPopstatsPopulationDensity && t.showMarketsPopstatsMedianAge === o.showMarketsPopstatsMedianAge && t.showOutOfMarketVisitors === o.showOutOfMarketVisitors && t.showOutOfMarketVisits === o.showOutOfMarketVisits && t.showMarketsVisitFrequency === o.showMarketsVisitFrequency && t.showMarketsAvgDwellTime === o.showMarketsAvgDwellTime && t.showMarketsMedianDwellTime === o.showMarketsMedianDwellTime && t.showMarketsEmployeesWorkforce === o.showMarketsEmployeesWorkforce && t.showMarketsPercentWhiteCollar === o.showMarketsPercentWhiteCollar && t.showMarketsVisitsByEmployees === o.showMarketsVisitsByEmployees && t.showMarketsMedianSalary === o.showMarketsMedianSalary && t.showMarketsInboundCommuters === o.showMarketsInboundCommuters && t.showMarketsNumBusinesses === o.showMarketsNumBusinesses && t.propertyNameFontFamily === o.propertyNameFontFamily && t.propertyNameFontWeight === o.propertyNameFontWeight && t.propertyNameFontSize === o.propertyNameFontSize && t.propertyAddressFontFamily === o.propertyAddressFontFamily && t.propertyAddressFontWeight === o.propertyAddressFontWeight && t.propertyAddressFontSize === o.propertyAddressFontSize && r === n || !1;
  }
}
export {
  ut as TenantsCalloutBox,
  c as outerBoxStyle
};
//# sourceMappingURL=index.es253.js.map
